<template>
  <div>
      <plan-table/>
  </div>
</template>
<script>
import PlanTable from './components/table/index'
export default {
  name: 'plan-planPackage',
  components: {
    PlanTable,
  },
}
</script>
